import { createContext, useContext } from 'react';

/** Settings broadcast by ControlLabel to wrapped control(s). `undefined` = no ControlLabel above. */
export type ControlLabelSettings = {
  /** The id of the native control input, generated by ControlLabel for label `for`-association. */
  id?: string;
  size?: 'sm' | 'md';
  required?: boolean;
  disabled?: boolean;
  error?: boolean;
};

export const ControlLabelContext = createContext<
  ControlLabelSettings | undefined
>(undefined);

/** Reads ControlLabel settings above. Precedence: own props > ControlLabelContext > defaults. */
export const useControlLabelSettings = (): ControlLabelSettings | undefined =>
  useContext(ControlLabelContext);
